import React, {Component} from "react";
import PropTypes from "prop-types";
import {connect} from "react-redux";
import PopupWrapper from "../Common/PopupWrapper";
import i18next from "i18next";
import GridView from "@mnjsplatform/components/lib/common/GridView/GridView";
import PlaceholderWrapper from "../Common/PlaceholderWrapper";
import MessageBox from "@mnjsplatform/components/lib/common/MessageBox";
import ScheduleVacationForm from "./ScheduleVacationForm";
import {renderHTML} from "@mnjsplatform/data/lib/utils/htmlUtils";

class ScheduleVacationCreatePopup extends Component {
    constructor(props, context) {
        super(props, context);

        this.state = {
            rowKey: null,
            showMessage: false,
            messageText: '',
            showProgress: false,
            progressText: null,
            inOperation: true
        };
    }

    componentDidMount() {
        this.initialize();
    }

    initialize = async () => {
        try {
            this.key = {NumYear: this.props.currentYear};
            if (this.props.row) {
                this.key.SubTabNum = this.props.row.TabNum;
            }
            await this.props.dispatch(this.props.SchedHolidayYear_GetTextPersPO.execute(this.key));
            await this.props.dispatch(this.props.ShedHolidayDetail_TitleSchHolPO.execute(this.key));
            await this.props.dispatch(this.props.dataItem.execute(this.key, {newItem: true}));

        } catch (e) {
            console.error(e);
        } finally {
            this.setState({inOperation: false});
        }
    }

    onSendRequest = async () => {
        try {
            this.setState({
                showProgress: true
            });
            await this.props.dispatch(this.props.ShedHolidayDetail_SendToBoss.execute(this.key));
            if (!this.props.ShedHolidayDetail_SendToBoss.isError) {
                this.onClose();
            }
        } finally {
            this.setState({
                showProgress: false
            });
        }
    }

    refreshDataItem = async () => {
        await this.props.dispatch(this.props.dataItem.refresh(this.key));
        await this.props.dispatch(this.props.SchedHolidayYear_GetTextPersPO.refresh());
        await this.props.dispatch(this.props.ShedHolidayDetail_TitleSchHolPO.refresh(this.key));
    }

    renderButtons = () => {
        return (<div className="modal-footer text-right">
            {!this.props.readOnly && <button type="button"
                                             className="btn btn-regular -goahead  ml1ex"
                                             onClick={this.onSendRequest}>{i18next.t((!this.props.row ? "SendToManager" : "Save"))}</button>}
            <button type="button" className="btn btn-regular"
                    onClick={this.props.onClose}>{i18next.t("Close")}</button>
        </div>)
    }

    renderInfo = () => {
        if (!this.props.ShedHolidayDetail_TitleSchHolPO.isInitialized || this.props.ShedHolidayDetail_TitleSchHolPO.inOperation) return null;
        const titleStr = this.props.ShedHolidayDetail_TitleSchHolPO.getField(0, 'Title');
        const titleErrStr = this.props.ShedHolidayDetail_TitleSchHolPO.getField(0, 'TitleErr');
        const titleRows = titleStr && titleStr.split('\n');
        const titleErrRows = titleErrStr && titleErrStr.split('\n');
        return (<>
            <div key="13">
                {titleRows && titleRows.map((row, index) => <div key={`13_${index}`}
                                                                 className="font-weight-bold">{renderHTML(row)}</div>)}
                {titleErrRows && titleErrRows.map((row, index) => <div key={`13_err_${index}`}
                                                                       className="font-weight-bold text-danger">{row}</div>)}
            </div>
        </>);
    }

    renderMsg = () => {
        if (!this.props.SchedHolidayYear_GetTextPersPO.isInitialized || this.props.SchedHolidayYear_GetTextPersPO.inOperation) return null;

        const isMess = this.props.SchedHolidayYear_GetTextPersPO.getField(0, 'IsMess');
        if (isMess === 0) {
            return null;
        }
        const mess_Text = this.props.SchedHolidayYear_GetTextPersPO.getField(0, 'Mess_Text');
        const mess_Clr = this.props.SchedHolidayYear_GetTextPersPO.getField(0, 'Mess_Clr');
        const mess_Size = this.props.SchedHolidayYear_GetTextPersPO.getField(0, 'Mess_Size');

        const mess_Text_Rows = mess_Text && mess_Text.split('\n');
        return (<div key="12">
            {mess_Text_Rows && mess_Text_Rows.map((row, index) => <div key={`12_${index}`}
                                                                       style={{
                                                                           color: `#${mess_Clr}`,
                                                                           fontSize: `${mess_Size}`
                                                                       }}>{row}</div>)}
        </div>);
    }

    onClose = () => {
        if (this.props.onClose) {
            this.props.onClose(true);
        }
    }

    render() {
        const title = this.props.row ? i18next.t("Schedule_Vacation_Year_FIO" , {
            year: this.props.currentYear, fio:  this.props.row.FIO })
        : i18next.t("Schedule_Vacation_Year" , {year: this.props.currentYear});
        return (<PopupWrapper popupVisible={true}
                              title={title}
                              staticTitle={i18next.t("Year_Schedule_Vacation_For_Employee")}
                              onClose={this.onClose} renderButtons={this.renderButtons}>

            {this.state.showProgress &&
                <PopupWrapper popupVisible={this.state.showProgress} title={i18next.t('Vacation_SendRequest')}
                              onClose={() => {
                                  this.setState({showProgress: false})
                              }}
                              renderButtons={() => {
                              }} maxWidthBody="300px" style={{marginTop: '200px'}}>
                    <div>{this.state.progressText}</div>
                </PopupWrapper>}
            <MessageBox visible={this.state.showMessage}
                        title={i18next.t('Status')}
                        messageText={this.state.messageText}
                        onClose={() => {
                            this.setState({showMessage: false});
                        }}
            />
            <PlaceholderWrapper placeholderId="ScheduleVacationCreatePopup_10" canCollapse={false} showSplitterLine={false} showHeaderTitle={false}
                                title={i18next.t("Edit_Schedule_Vacation")}>
                {this.renderMsg()}
                {this.renderInfo()}
                <GridView dataItem={this.props.dataItem}
                          readOnly={this.props.readOnly}
                          addButtonText={i18next.t("Create_Schedule_Vacation_Element")}
                          afterEditRow={this.refreshDataItem}
                          afterAddRow={this.refreshDataItem}
                          afterDeleteRow={this.refreshDataItem}
                          showHeader={true}
                          useItemStyle={true}
                          renderAddForm={(props) => {
                              return <ScheduleVacationForm addMode={true} {...props}
                                                           refreshDataItem={this.refreshDataItem}
                                                           title={title}
                              />;
                          }}
                          renderEditForm={(props) => {
                              return <ScheduleVacationForm addMode={false} {...props}
                                                           title={title}
                                                           rowKey={props.dataItem.getRowKey(props.row)}
                                                           refreshDataItem={this.refreshDataItem}
                              />;
                          }}
                />
            </PlaceholderWrapper>
        </PopupWrapper>)
    }
}

ScheduleVacationCreatePopup.propTypes = {
    dispatch: PropTypes.func.isRequired,
    readOnly: PropTypes.bool,
    onClose: PropTypes.func,
    dataItem: PropTypes.object,
    row: PropTypes.object,
    ShedHolidayDetail_TitleSchHolPO: PropTypes.object,
    ShedHolidayDetail_SendToBoss: PropTypes.object,
    SchedHolidayYear_GetTextPersPO: PropTypes.object
}

ScheduleVacationCreatePopup.defaultProps = {
    readOnly: false
}

function mapStateToProps(state, ownProps) {
    return {
        ShedHolidayDetail_TitleSchHolPO: state.vacationState.ShedHolidayDetail_TitleSchHolPO,
        ShedHolidayDetail_SendToBoss: state.vacationState.ShedHolidayDetail_SendToBoss,
        SchedHolidayYear_GetTextPersPO: state.vacationState.SchedHolidayYear_GetTextPersPO
    }
}

export default connect(mapStateToProps)(ScheduleVacationCreatePopup)